import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'


// Get All Tariff Rates
export const getTariffRatesReq = (action) => {
    const params = action?.data || {};
    return axiosInstance.get(apiEndpoints.GET_TARIFF_RATES_API, { params })
}

// Get Tariff Rates By Head
export const getTariffRatesByHeadReq = (action) => {
    const { head_id } = action?.data || {};
    const url = apiEndpoints.GET_TARIFF_RATES_BY_HEAD_API.replace(':head_id', head_id);
    return axiosInstance.get(url)
}

// Get Tariff Rate Details by ID
export const getTariffRateDetailsReq = (action) => {
    const { id } = action?.data || {};
    const url = apiEndpoints.GET_TARIFF_RATE_DETAILS_API.replace(':id', id);
    return axiosInstance.get(url)
}

// Create Tariff Rate
export const createTariffRateReq = (action) => {
    const payload = action?.data || {};
    const body = { ...payload };
    delete body.onSuccess;

    return axiosInstance.post(apiEndpoints.CREATE_TARIFF_RATE_API, body)
}

// Update Tariff Rate
export const updateTariffRateReq = (action) => {
    const payload = action?.data || {};
    const { id } = payload;
    const url = apiEndpoints.UPDATE_TARIFF_RATE_API.replace(':id', id);

    const body = { ...payload };
    delete body.id;
    delete body.onSuccess;

    return axiosInstance.put(url, body)
}

// Update Tariff Rate Status (Activate/Deactivate)
// Update Tariff Rate Status (Activate/Deactivate)
export const updateTariffRateStatusReq = (action) => {
    const payload = action?.data || {};
    const { id, status } = payload;
    const url = apiEndpoints.UPDATE_TARIFF_RATE_STATUS_API.replace(':id', id);

    return axiosInstance.patch(url, { status })
}

// Delete Tariff Rate
export const deleteTariffRateReq = (action) => {
    const { id } = action?.data || {};
    const url = apiEndpoints.DELETE_TARIFF_RATE_API.replace(':id', id);

    return axiosInstance.delete(url)
}
